import React, { useState } from 'react'
import A from '@components/A'
import {
  StyledListContainer,
  StyledUL,
  StyledLI,
  StyledSpanTitle,
} from './style'
import moment from 'moment'
import LoadMoreButton from '../Results/components/LoadMoreButton'

const List = ({ tabName, listContent }) => {
  if (tabName === 'Accolades') tabName = 'Accolade'
  if (tabName === 'Insights') tabName = 'Article'
  if (tabName === 'Events') tabName = 'Event'
  const contentfulType = `Contentful${tabName}`
  const numItemsPerPage = 20
  const [numItemsToDisplay, setNumItemsToDisplay] = useState(numItemsPerPage)
  const hasMoreItems = numItemsToDisplay < listContent?.length
  const loadMore = () => {
    if (hasMoreItems) setNumItemsToDisplay(numItemsToDisplay + numItemsPerPage)
  }

  return (
    <StyledListContainer>
      <StyledUL>
        {listContent
          .slice(0, numItemsToDisplay)
          .map(({ title, id, publicationDate, slug, category }) => (
            <StyledLI key={id}>
              <A
                contentType={contentfulType}
                to={slug}
                category={category?.slug}
              >
                <StyledSpanTitle color={'black'} hover={'gold'}>
                  {title}
                </StyledSpanTitle>
                <span style={{ color: 'black' }}>
                  {` - ` + moment(publicationDate).format('MMMM Do, YYYY')}
                </span>
              </A>
            </StyledLI>
          ))}
      </StyledUL>
      {hasMoreItems && (
        <LoadMoreButton
          margin="25px 0 0"
          smallerWidth="82.5%"
          loadMore={loadMore}
        />
      )}
    </StyledListContainer>
  )
}

export default List
